export default "__VITE_ASSET__1c76ea76__"